<template lang="pug">
  .analise(v-if="dadosCadastros !== undefined")
    el-card(shadow='hover').card-collapse
      el-col(:span='8').center
        app-display(label="Nome do Interessado:", :content="processo.nomeRazaoSocialInteressado")
        app-display(label="Número do processo:", :content="processo.numeroProcesso")
      el-col(:span='8')
        app-display(label="CPF do Interessado:", :content="processo.cpfCnpjInteressado")
        app-display(label="Tipo de Processo:", :content="processo.tipo.nome")
      app-opcoes-header-analise.right(
        :idProcesso="processo.id",
        :numeroProcesso="processo.numeroProcesso",
        :tipoProcesso="processo.tipo.codigo",
        :protocolo="processo.numeroProtocolo",
        :idDespacho="dadosCadastros.despacho.id",
        :btnSolicitarInformacao="!isBa"
        :isSubProcesso="true"
      )
    validation-observer(ref='validation' tag='form')
      el-card(shadow="hover").card-collapse
        app-despachos(
          :idProcesso="idProcesso",
          :data="dadosCadastros.setores",
          @getDownload="getDownload",
          @getAnotacao="getAnotacao"
        )

      el-card(shadow="hover", v-if="dadosCadastros && showInfoTecnicoDeCampo").card-collapse
        div(v-if="visualizarBotoes")
          validation-provider(rules="required", v-slot="{ errors }")
            .container-buttons
              el-radio-group(
                v-model="despacho",
                name="parecer",
              )
                div.padding.input(:class="{'erro' : errors.length}")
                  el-radio(:label="false", :border="true") Documentos georreferenciamento
                  el-radio(:label="true", :border="true") Despacho
              span.help.erro {{ errors[0] }}
        div(v-if="despacho && showModalDespacho")
          validation-provider(rules="required", v-slot="{ errors }")
            p.label Despacho
            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="dadosCadastros.despacho.textoDespacho",
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}
          app-anexo(
            :id="'upload-anexo-despacho'",
            v-if="anexos && dadosCadastros.despacho && dadosCadastros.despacho.documentos.length === 0",
            @uploadFile="uploadFile",
            :files="anexos",
            @removeFile="removeFile"
            @downloadDocumentoCadastro="downloadDocumentoCadastro",
            :tipoExibir="'ANEXO_ANALISE'"
          )
        div(v-else)
          .margin-medium-top(v-if="isGeomensor() || isFiscalizador()")
            app-divider.margin-top-bottom(
              v-if="pecasTecnicas && pecasTecnicas.length > 0 && !isRo"
              label="Peças Técnicas",
              :showBorder="false",
            )

            el-table.margin-bottom(
              v-if="pecasTecnicas && pecasTecnicas.length > 0 && !isRo"
              :data="pecasTecnicas"
            )
              el-table-column(
                prop="nome",
                label="Nome do Arquivo:"
              )
              el-table-column(
                width="100"
              )
                template(slot-scope='scope')
                  .flex
                    app-action-button(
                      icone="download",
                      @click="getDownload(scope.row)",
                      cor="#666666",
                      text="Baixar Documento"
                    )

            p(v-if="!pecasTecnicas && !isRo") Nenhuma peça técnica encontrada.

          template.extra-margin-top-bottom(v-if="isGeomensor() || isFiscalizador()")
            app-dados-gerais-os(
              v-if="showCodigoEstado && !isReurb"
              :numeroIterpa="dadosCadastros.despacho.numeroIterpa",
              @setCodigo="setCodigoIterpa"
            )

            app-dados-responsavel(
              v-if="showResponsavel && isGeomensor()"
              :responsavel="responsavel"
              :processo="processo"
            )

            div(v-if="isReurb")
              el-row(
                :gutter="30"
              )
                el-col(:span="12")
                  validation-provider(:rules='required.rules', v-slot="{ errors }")
                    app-label(
                      label="Lote"
                    )
                    el-input.input(
                      v-model="loteEndereco"
                      :class="{'error' : errors.length}"
                      :maxlength="50"
                      type="text"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(:span="12")
                  validation-provider(:rules='required.rules', v-slot="{ errors }")
                    app-label(
                      label="Quadra"
                    )
                    el-input.input(
                      v-model="quadra"
                      :class="{'error' : errors.length}"
                      :maxlength="50"
                      type="text"
                    )
                    span.help.erro {{ errors[0] }}

              el-row(
                :gutter="30"
              )
                el-col(:span="12")
                  validation-provider(:rules='required.rules', v-slot="{ errors }")
                    app-label(
                      label="Rua"
                    )
                    el-input.input(
                      v-model="rua"
                      :class="{'error' : errors.length}"
                      :maxlength="50"
                      type="text"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(:span="12")
                  validation-provider(:rules='required.rules', v-slot="{ errors }")
                    app-label(
                      label="Bairro"
                    )
                    el-input.input(
                      v-model="bairro"
                      :class="{'error' : errors.length}"
                      :maxlength="50"
                      type="text"
                    )
                    span.help.erro {{ errors[0] }}

              el-row(
                :gutter="30"
              )
                el-col(:span="12")
                  app-label(
                    label="Complemento"
                    :required="false"
                  )
                  el-input.input(
                    v-model="complemento"
                    :maxlength="50"
                    type="text"
                  )
                el-col(:span="6")
                  validation-provider(:rules='required.rules', v-slot="{ errors }")
                    app-label(
                      label="Código Imóvel"
                    )
                    el-input.input(
                      v-model="codigoImovel"
                      :class="{'error' : errors.length}"
                      :maxlength="50"
                      type="text"
                      :disabled="true"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(:span="6")
                  validation-provider(:rules="!digitarCodigoArt ? 'required' : ''", v-slot="{ errors }")
                    app-label(
                      label="Código ART/TRT:"
                      :required="digitarCodigoArt"
                    )
                    el-input.input(
                      v-model="codigoArtTrt"
                      :value='codigoArtTrt'
                      :class="{'error' : errors.length}"
                      :maxlength="50"
                      type="text"
                      :disabled="!digitarCodigoArt"
                    )
                    span.help.erro {{ errors[0] }}
            template.extra-margin-top-bottom(v-if="isGeomensor()")
              template
                app-label.campo(
                  label="Upload documento ART/TRT:"
                  :required="uploadDocumentoArt"
                  v-if="uploadDocumentoArt"
                )

                validation-provider(:rules="uploadDocumentoArt ? isValidate : ''", v-slot="{ errors }")
                  app-anexo(
                    :id="'upload-anex'",
                    v-model="documentoArtTrtOs",
                    :tiposArquivosPermitidos="'.pdf'",
                    :files="documentoArtTrtOs",
                    :showUpload="uploadDocumentoArt",
                    :exibirDelete="uploadDocumentoArt",
                    :errors="errors",
                    @downloadDocumentoCadastro="getDownload",
                    @uploadFile="uploadArt",
                    @removeFile="removeArt"
                  )
            div(v-if="isGeomensor()")
              validation-provider(rules="required", v-slot="{ errors }", v-if="!isReurb && exibirTipoAnaliseGeo")
                div(:class="{'error' : errors.length}")
                  div.tipo-de-analise
                    span Tipo de análise
                  el-radio(v-model="tipoAnalisePlanilha" :label="true" border) Utilizar planilha ODS
                  el-radio(v-model="tipoAnalisePlanilha" :label="false" border) Definir limites e Confrontações
              app-documentos(
                v-if="!isReurb",
                aba="Georreferenciamento",
                :isAnalise="true",
                :idUploadDocumento="'documentoGeorreferenciamento'",
                :titulo="'Georreferenciamento'",
                :maxSize='25000',
                :valid-extensions="extensoes",
                :documentos="documentosGeomensor",
                :tiposDocumentos="tipoDocumentosGeomensor",
                :tiposDocumentosObrigatorios="tipoDocumentosGeomensorObrigatorios",
                :pecasTecnicas="true",
                :pecasTecnicasSalvas="pecasTecnicas"
                :mensagemErroFilaPlantaMemorial="mensagemErroPlantaMemorial",
                :observer="this.$refs.validation",
                @mudaTipo="mudaTipo",
                @setDadosPlanilha="setDadosPlanilha",
                @removedDoc="removeFile",
                @addedDoc="addedDoc",
                :isRequired="showRequired"
              )
              div.extra-margin-top-bottom(v-if="showMapa || isReurb")
                validation-provider(:rules='required.rules', v-slot="{ errors }", name="Georreferenciamento/Geometria")
                  mapa-analise-geomensor(
                    v-model="dadosCadastros.despacho.localizacoes",
                    :localizacoes="dadosCadastros.despacho.localizacoes",
                    :tipoCadastro="processo.tipo.codigo",
                    name="Geometria",
                    idMapa="mapaAnaliseGeomensor"
                    :errors="errors"
                    :addOrtoFotos="true"
                    @shapefileUploaded="setShapefile"
                    @shapefileRemoved="removeShapefile"
                  )
                  span.help.erro {{ errors[0] }}

            div(v-if="isFiscalizador()")
              app-documentos(
                :isAnalise="true"
                :idUploadDocumento="'documentoFiscalizacao'"
                :titulo="'Relatório de Fiscalização'"
                :maxSize='25000',
                :valid-extensions="['png','jpg','jpeg','pdf','doc','docx']",
                :documentos="documentosFiscalizador"
                :tiposDocumentos="tipoDocumentosFiscalizador"
                :tiposDocumentosObrigatorios="tipoDocumentosFiscalizador"
                :pecasTecnicas="true"
                :removeOutros="true"
                @removedDoc="removeFile"
                aba="Fiscalizacao"
                :observer="this.$refs.validation",
                :isRequired="showRequired"
              )

          template.extra-margin-top-bottom(v-if="isVistoriador()")
            template
              app-documentos(
                :isAnalise="true"
                :idUploadDocumento="'documentoVistoria'"
                :titulo="'Laudo de Vistoria'"
                :maxSize='25000',
                :valid-extensions="['png','jpg','jpeg','pdf','doc','docx']",
                :documentos="documentosVistoriador"
                :tiposDocumentos="tipoDocumentosVistoriador"
                :tiposDocumentosObrigatorios="tipoDocumentosVistoriador"
                :pecasTecnicas="true"
                :removeOutros="true"
                @removedDoc="removeFile"
                aba="Vistoria"
                :observer="this.$refs.validation",
                :isRequired="showRequired"
              )
          template.extra-margin-top-bottom(v-if="isAdministrativo()")
            template
              app-documentos(
                :isAnalise="true"
                :idUploadDocumento="'documentoAdministrativo'"
                titulo="Laudo Administrativo"
                :maxSize='25000',
                :valid-extensions="['png','jpg','jpeg','pdf','doc','docx']",
                :documentos="documentosAdministrativo"
                :tiposDocumentos="tipoDocumentosAdministrativo"
                :tiposDocumentosObrigatorios="tipoDocumentosAdministrativo"
                :pecasTecnicas="true"
                :removeOutros="true"
                @removedDoc="removeFile"
                aba="Administrativo"
                :observer="this.$refs.validation"
              )
              app-divider.margin-top-bottom(
                label="Beneficiários",
                :showBorder="false",
              )
              beneficiarios(
                v-if="processo"
                modulo="analise"
                scope="beneficiarios"
                :observer="this.$refs.validation"
                :processo="processo"
                @updateBeneficiariosLista="updateBeneficiariosLista"
                @changedBeneficiarios="beneficiariosChanged = true"
                @hasBeneficiarios="hasBeneficiarios"
              )
      el-card(shadow="hover" v-if="showDespachoTecnicoCampo").card-collapse
        div(v-if="(dadosCadastros.despacho.acao && dadosCadastros.despacho.acao.includes('ARQUIVAMENTO')) || isBa")
          validation-provider(rules="required", v-slot="{ errors }")
            .flex-despacho
              p.label Despacho
                span.required &nbsp * &nbsp
              el-button(type="primary", @click="openModalDespacho") Modelo &nbsp
                .fa.fa-file

            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="dadosCadastros.despacho.textoDespacho",
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}
            app-anexo(
              :id="'upload-anexo-despacho'",
              :files="anexos",
              :tipoExibir="'ANEXO_ANALISE'"
              @uploadFile="uploadFile",
              @removeFile="removeFile"
              @downloadDocumentoCadastro="downloadDocumentoCadastro",
            )
        app-radios-tramitacao(
          :radios="acoesRadio",
          :isDecisao="isDecisao",
          :isEsconderEncaminhamento="dadosCadastros.encaminhamento"
          @changeRadio="changeRadio",
          :radioInicial="dadosCadastros.despacho.acao",
          v-if="!isBa"
        )
      app-buttons-cadastro(
        :isUltimoPasso="isUltimoPasso",
        :isPrimeiroPasso="!isUltimoPasso",
        :showButtonSalvar="true",
        :showButtonProximo="true",
        @proximo="proximo",
        @finalizar="finalizar",
        @cancelar="cancelar",
        @salvar="salvar",
        @voltar="voltar"
      )
      div
        app-modal-selecionar-modelo-notificacao(
          :tiposModelo="tiposModelo",
          :titulo="tituloModalModelo",
          :idProcesso="processo.id"
          v-if="showModalDespacho",
          :showModal="showModalDespacho"
          @closeModal="fecharModalDespacho",
          @setTextoDespacho="setTextoDespacho"
        )
</template>
<script>
import FileSaver from 'file-saver'
import AppDespachos from '@/components/AppDespachos'
import AppDadosCadastro from '@/components/AppDadosCadastro'
import AppActionButton from '@/components/AppActionButton'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppAnexo from '@/components/AppAnexo'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalSelecionarModeloNotificacao from './components/AppModalSelecionarModeloNotificacao'
import { mapActions, mapGetters } from 'vuex'
import AppOpcoesHeaderAnalise from './components/modal/AppOpcoesHeaderAnalise'
import AppDisplay from '@/components/AppDisplay'
import AppPublicacao from '@/components/AppPublicacao'
import AppDivider from '@/components/AppDivider'
import AppDownloadAnexo from '@/components/AppDownloadAnexo'
import AppDadosGeraisOs from '@/components/AppDadosGeraisOs'
import AppDocumentos from '../central/components/cadastro/AppDocumentos.vue'
import MapaAnaliseGeomensor from '@/screens/analise/components/MapaAnaliseGeomensor'
import AppDadosResponsavel from '@/components/shared/AppDadosResponsavel'
import Beneficiarios from './Beneficiarios.vue'
import AppLabel from '@/components/AppLabel'

const regrasAnalise = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default
const {
  exibirMapaTecnicoCampo,
  exibirResponsavel,
  exibirCodigoEstado,
  pegarResponsavel,
  notShowCardInfoTecnicoCampo
} = regrasAnalise.cadastro

const { tiposModeloDefault, setoresArquivamentoTecnicoCampo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

const { setores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
    AppDespachos,
    AppDadosCadastro,
    AppEditorTexto,
    AppButtonsCadastro,
    AppAnexo,
    AppActionButton,
    AppRadiosTramitacao,
    AppOpcoesHeaderAnalise,
    AppDisplay,
    AppPublicacao,
    AppDivider,
    AppDownloadAnexo,
    AppDadosGeraisOs,
    AppLabel,
    AppDocumentos,
    MapaAnaliseGeomensor,
    AppDadosResponsavel,
    Beneficiarios,
    AppModalSelecionarModeloNotificacao
  },

  mixins: [AppNotificacao],

  props: {
    idProcesso: {
      required: true
    },
    acaoCaixa: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      dataDespachos: [],
      dadosCadastros: undefined,
      processo: null,
      exibirTipoAnaliseGeo: false,
      anexos: [],
      tipoAnalisePlanilha: true,
      radios: [],
      showModal: false,
      idUsuario: null,
      extensoes: ['pdf', 'jpeg', 'png', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar', 'jpg', 'doc'],
      numeroProcesso: '',
      usuario: null,
      documentosValidar: true,
      pecasTecnicas: [],
      funcao: [],
      documentosGeomensor: [],
      documentosVistoriador: [],
      documentosFiscalizador: [],
      documentosAdministrativo: [],
      tipoDocumentosGeomensor: [],
      tipoDocumentosGeomensorObrigatorios: [],
      tipoDocumentosGeomensorAux: [],
      tipoDocumentosVistoriador: [],
      tipoDocumentosFiscalizador: [],
      documentosAutomatizados: [],
      tipoDocumentosAdministrativo: [],
      responsavel: {
        nome: '',
        codigoIncra: '',
        creaRnp: '',
        formacao: ''
      },
      denominacaoImovel: '',
      jsonPlanilha: null,
      tipoPlanilha: null,
      despacho: false,
      mensagemErroPlantaMemorial: '',
      beneficiarios: [],
      beneficiariosChanged: false,
      loteEndereco: '',
      quadra: '',
      rua: '',
      bairro: '',
      complemento: '',
      codigoImovel: '',
      isPrimeiroPasso: false,
      isUltimoPasso: true,
      menssagemRetorno: '',
      atualizandoJsonPlanilha: false,
      codigoArtTrt: null,
      municipio: {},
      digitarCodigoArt: false,
      documentoArtTrtOs: [],
      uploadDocumentoArt: false,
      estado: process.env.ESTADO,
      acoesRadio: [],
      isDecisao: false,
      showModalDespacho: false,
      tiposModelo: tiposModeloDefault,
      tituloModalModelo: 'Modelos de Despacho',
      isValidate: null,
      showRequired: true
    }
  },

  async created () {
    this.usuario = await this.getUsuario()
    const features = await this.getFeaturesSistema()
    this.exibirTipoAnaliseGeo = features?.analiseGeoAutomatizadaAtiva
    await this.montarTela()
    this.tipoDocumentosGeomensor = await this.findTiposDocumentoTipoProcesso({
      url: 'geo',
      tipo: this.processo.tipo.codigo
    })
    if (this.isPa) {
      this.tipoDocumentosGeomensorObrigatorios = this.tipoDocumentosGeomensor.filter(f => !f.codigo.includes('OUTRO'))
    }
    if (this.isBa) {
      this.tipoDocumentosGeomensorObrigatorios = this.tipoDocumentosGeomensor.filter(
        f => f.codigo === 'TABELA_DADOS_CARTOGRAFICOS' || f.codigo === 'ART_TRT' ||
        f.codigo === 'CARTAS_CONFRONTANTES' || f.codigo === 'EDITAL_MEDICAO' || f.codigo === 'CERTIDAO_PUBLICIDADE'
      )
    }
    this.tipoDocumentosGeomensorAux = JSON.parse(JSON.stringify(this.tipoDocumentosGeomensor)) // clona o objeto e nao o endereço de memoria
    this.tipoDocumentosVistoriador = await this.findDocumentos('vistoriador')
    this.tipoDocumentosFiscalizador = await this.findDocumentos('fiscalizador')
    this.tipoDocumentosAdministrativo = await this.findDocumentos(
      'administrativo'
    )
    this.carregarResponsavel()
    this.ajustaDocumentosGeo(this.tipoAnalisePlanilha)
  },

  computed: {
    isPa () {
      return this.estado === 'pa'
    },
    isBa () {
      return this.estado === 'ba'
    },
    isRo () {
      return this.estado === 'ro'
    },
    showMapa () {
      return (
        this.usuario?.perfilSelecionado &&
        exibirMapaTecnicoCampo.setores.includes(
          this.usuario?.perfilSelecionado.setor.codigo
        ) &&
        exibirMapaTecnicoCampo.status.includes(this.processo?.status)
      )
    },

    showDespachoTecnicoCampo () {
      return setoresArquivamentoTecnicoCampo.includes(this.processo.tipo.codigo)
    },

    showResponsavel () {
      return (
        this.usuario?.perfilSelecionado &&
        exibirResponsavel.setores.includes(
          this.usuario?.perfilSelecionado.setor.codigo
        ) &&
        exibirResponsavel.status.includes(this.processo?.status)
      )
    },

    showCodigoEstado () {
      return (
        this.usuario?.perfilSelecionado &&
        exibirCodigoEstado.setores.includes(
          this.usuario?.perfilSelecionado.setor.codigo
        ) &&
        exibirCodigoEstado.status.includes(this.processo?.status)
      )
    },

    isReurb () {
      return this?.processo?.tipo?.codigo === 'REGULARIZACAO_URBANA'
    },

    visualizarBotoes () {
      // TODO deixar comentado até a atividade ser concluída
      // return this.processo.status === 'EM_REVISAO'
      return false
    },

    notificarTecnico () {
      return (this.digitarCodigoArt || this.uploadDocumentoArt) && this.documentoArtTrtOs
    },

    required () {
      if (this.dadosCadastros.despacho.acao === 'EM_ANALISE.TECNICO_DE_CAMPO.GAM') {
        return { rules: 'required', label: true }
      }
      return { rules: '', label: false }
    },

    showInfoTecnicoDeCampo () {
      return !(notShowCardInfoTecnicoCampo.status.includes(this.processo.status) && notShowCardInfoTecnicoCampo.funcoes.includes(this.funcao))
    }
  },

  watch: {
    quadra: {
      handler () {
        this.codigoImovelConcatedString()
      }
    },
    loteEndereco: {
      handler () {
        this.codigoImovelConcatedString()
      }
    },
    bairro: {
      handler () {
        this.codigoImovelConcatedString()
      }
    },
    tipoAnalisePlanilha: {
      handler (val) {
        this.ajustaDocumentosGeo(val)
        if (!val && this.documentosGeomensor && this.documentosGeomensor.find(d => d.tipoDocumento.codigo === 'TABELA_DADOS_CARTOGRAFICOS')) {
          this.confirmBox(
            this.$messages.TROCAR_TIPO_ANALISE_GEO,
            this.$messages.TITULO_WARNING,
            () => {
              this.atualizaDadosSubProcesso(this.dadosCadastros.despacho.id)
                .then(() => {
                  this.montarTela()
                })
            },
            () => {
              this.tipoAnalisePlanilha = true
            }
          )
        }
      }
    }
  },

  methods: {
    ajustaDocumentosGeo (valor) {
      if (valor) {
        this.tipoDocumentosGeomensor = this.tipoDocumentosGeomensorAux
      } else {
        this.tipoDocumentosGeomensor = this.tipoDocumentosGeomensorAux.filter(f => f.codigo !== 'TABELA_DADOS_CARTOGRAFICOS')
      }
      if (this.isPa) {
        this.tipoDocumentosGeomensorObrigatorios = this.tipoDocumentosGeomensor.filter(f => !f.codigo.includes('OUTRO'))
      }
    },
    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'DRD_DRL':
        case 'RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO':
        case 'ART_TRT':
        case 'CARTAS_CONFRONTANTES':
        case 'EDITAL_MEDICAO':
        case 'CERTIDAO_PUBLICIDADE':
          this.extensoes = ['pdf']
          break
        case 'RELATORIO_DE_PROCESSAMENTO':
        case 'ARQUIVOS_GNSS':
          this.extensoes = ['zip']
          break
        case 'TABELA_DADOS_CARTOGRAFICOS':
          this.extensoes = ['ods', 'xlsx']
          break
        case 'OUTROS_GEOMENSOR':
          this.extensoes = ['pdf', 'jpeg', 'png', 'jpg', 'doc', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar']
          break
      }
    },
    ...mapActions({
      getSubProcesso: 'subProcesso/getSubProcesso',
      atualizaDadosSubProcesso: 'subProcesso/atualizaDadosSubProcesso',
      tarefa: 'processo/tarefa',
      getProcessoById: 'processo/getProcessoById',
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      findTiposDocumentoTipoProcesso:
        'tipoDocumento/findTiposDocumentoTipoProcesso',
      updateBeneficiariosByProtocolo: 'cadastro/updateBeneficiariosByProtocolo',
      getFeaturesSistema: 'features/getFeaturesSistema'
    }),

    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          if (documento.id) {
            axios({
              method: 'DELETE',
              url: `documento/delete`,
              data: documento,
              responseType: 'blob'
            })
              .then(() => {
                this.deleteAnexo(documento)
              })
              .catch(() => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  'Houve um erro ao remover o anexo.'
                )
              })
          } else {
            this.deleteAnexo(documento)
          }
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.id === documento.id)
        )
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.key === documento.key)
        )
        this.anexos.splice(index, 1)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    cancelar () {
      this.$router.push({name: 'EM_ANALISE_OS'})
    },

    getAnotacao (emit) {
      this.dataDespachos[emit.indexItem].despachos[emit.indexSubItem].anotacao =
        emit.value
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    openModalDespacho () {
      if (this.isReurb &&
        (this.processo.setor === 'DEAF' ||
          this.processo.setor === 'DJ' ||
          this.processo.setor === 'GP' ||
          this.processo.setor === 'GEO' ||
          setores.GCG_CGIR.includes(this.processo.setor))) {
        this.tiposModelo = [4]
        this.tituloModalModelo = 'Modelo de Despacho Reurb'
      }
      this.showModalDespacho = true
    },

    fecharModalDespacho () {
      this.showModalDespacho = false
    },

    setTextoDespacho (textoDespacho) {
      this.$refs.editorTexto.text = textoDespacho
      this.$refs.editorTexto.emitTextChange()
    },

    // TODO: MESCLAR METODOS SALVAR E FINALIZAR (REFACTOR)
    async salvar () {
      try {
        if (this.notificarTecnico) {
          this.confirmBox(
            this.$messages.AVISO_ART_TRT,
            this.$messages.TITULO_WARNING,
            async () => {
              await this.execucao('subprocessodespacho/salvar', 'Análise salva!')
            }
          )
        } else {
          await this.execucao('subprocessodespacho/salvar', 'Análise salva!')
        }
      } catch (error) {
        const messagemDeErro = Array.isArray(error.erros)
          ? error.erros.join(';')
          : 'Houve um erro ao salvar a análise.'
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          messagemDeErro
        )
      }
    },

    async execucao (rota, titulo) {
      await this.atualizarDados()
      await this.atualizaDocumentos()
      await axios({
        method: 'post',
        data: this.dadosCadastros.despacho,
        url: rota,
        error: true
      })
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        titulo
      )
      this.montarTela()
    },

    async finalizar () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }
      try {
        if (this.dadosCadastros.despacho.acao === 'ARQUIVAMENTO.SISTEMA.SISTEMA.AUTOCOMPLETE') {
          this.confirmBox(
            this.$messages.FINALIZAR_ANALISE,
            this.$messages.TITULO_WARNING,
            async () => {
              await this.execucao('processo/arquivarProcesso', 'Análise finalizada. Processo enviado para o setor DEAF.')
              this.$router.push({name: 'EM_ANALISE_OS'})
            }
          )
        } else if (this.notificarTecnico) {
          this.confirmBox(
            this.$messages.AVISO_ART_TRT,
            this.$messages.TITULO_WARNING,
            async () => {
              await this.execucao('subprocessodespacho/finalizar', 'Análise finalizada.')
              this.$router.push({name: 'EM_ANALISE_OS'})
            }
          )
        } else {
          this.confirmBox(
            this.$messages.FINALIZAR_ANALISE,
            this.$messages.TITULO_WARNING,
            async () => {
              await this.execucao('subprocessodespacho/finalizar', 'Análise finalizada.')
              this.$router.push({name: 'EM_ANALISE_OS'})
            }
          )
        }
      } catch (error) {
        const erroValidacao = error.status === 422
        const tipoErro = !erroValidacao
          ? this.$messages.TIPO_ERROR
          : this.$messages.TIPO_WARNING
        const tituloErro = !erroValidacao
          ? this.$messages.TITULO_ERROR
          : this.$messages.TITULO_WARNING
        const messagemDeErro = Array.isArray(error.erros)
          ? error.erros.join(';')
          : 'Houve um erro ao finalizar a analise.'
        this.showNotificacao(tipoErro, tituloErro, messagemDeErro)
      }
    },

    async proximo () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }

      await this.salvar()
      window.location.href = `${process.env.URL_AUTOMATIZADO_GEO}/#/${this.tipoAnalisePlanilha ? 'nova-analise' : 'nova-analise-arquivo'}/${this.processo.id}`
    },

    atualizaDocumentos () {
      const docs = this.documentosGeomensor.concat(
        this.documentosFiscalizador,
        this.documentosVistoriador,
        this.documentosAdministrativo,
        this.documentosAutomatizados,
        this.anexos.map(d => this.formataDocumento(d))
      )
      this.dadosCadastros.despacho.documentos = docs.map(documento => {
        return {
          id: documento.id,
          caminho: documento.caminho,
          key: documento.fileKey,
          nome: documento.fileName,
          tipo: documento.tipoDocumento
        }
      })
    },

    montarDocumentosTecnicoCampo (documentos) {
      documentos.map(documento => {
        switch (documento.tipo.codigo) {
          case 'ARQUIVOS_LITERAIS':
          case 'ARQUIVOS_GNSS':
          case 'OUTROS_GEOMENSOR':
          case 'MAPAS':
          case 'ART_TRT':
          case 'TABELA_DADOS_CARTOGRAFICOS':
          case 'ARQUIVOS_GRAFICOS':
          case 'MEMORIAL_DESCRITIVO':
          case 'PLANTA':
          case 'MEMORIAL_DESCRITIVO_INDIVIDUAL':
          case 'PLANTA_INDIVIDUAL':
          case 'DRD_DRL':
          case 'RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO':
          case 'RELATORIO_DE_PROCESSAMENTO':
          case 'CARTAS_CONFRONTANTES':
          case 'EDITAL_MEDICAO':
          case 'CERTIDAO_PUBLICIDADE':
            this.documentosGeomensor.push(this.formataDocumento(documento))
            break
          case 'OUTROS_VISTORIADOR':
          case 'LAUDO_VISTORIA':
            this.documentosVistoriador.push(this.formataDocumento(documento))
            break
          case 'OUTROS_FISCALIZADOR':
          case 'RELATORIO_FISCALIZACAO':
            this.documentosFiscalizador.push(this.formataDocumento(documento))
            break
          case 'OUTROS_ADMINISTRATIVO':
          case 'ATA_REUNIAO':
            this.documentosAdministrativo.push(this.formataDocumento(documento))
            break
          case 'RELATORIO_GERAL_GEORREFERENCIAMENTO':
          case 'RELATORIO_ANALISE_GERAL':
          case 'ARQUIVO_BRUTO_GEOREFERENCIAMENTO':
          case 'RELATORIO_GERAL_VALIDACAO_GEORREFERENCIAMENTO':
            this.documentosAutomatizados.push(this.formataDocumento(documento))
            break
          case 'ANEXO_ANALISE':
            this.anexos.push(documento)
            break
        }
      })
    },
    async montarTela () {
      this.documentosAutomatizados.length = 0
      this.documentosGeomensor.length = 0
      this.documentosVistoriador.length = 0
      this.documentosFiscalizador.length = 0
      this.documentosAdministrativo.length = 0
      const response = await this.getSubProcesso({ id: this.idProcesso })
      this.tipoAnalisePlanilha = this.exibirTipoAnaliseGeo ? response.despacho.analiseComPlanilha : true
      this.funcao = response.despacho.funcao
      this.loteEndereco = response.despacho.loteEndereco
      this.quadra = response.despacho.quadra
      this.documentoArtTrtOs = response?.despacho?.documentoArtTrtOs ? [response?.despacho?.documentoArtTrtOs] : []
      this.uploadDocumentoArt = response?.despacho?.uploadDocumentoArt
      this.digitarCodigoArt = response.despacho.digitarCodigoArt
      this.codigoArtTrt = response.despacho.codigoArtTrt
      this.rua = response.despacho.rua
      this.bairro = response.despacho.bairro
      this.complemento = response.despacho.complemento
      this.codigoImovel = response.despacho.codigoImovel
      this.municipio = response.despacho.municipio
      this.isUltimoPasso = this.exibirTipoAnaliseGeo ? (response.despacho.funcao === 'GEOMENSOR' ? response?.despacho?.analiseAutomaticaGeomensorFinalizada : true) : true
      this.montarDocumentosTecnicoCampo(response.despacho.anexosGeomensor)
      this.montarDocumentosTecnicoCampo(response.despacho.anexosFiscalizador)
      this.montarDocumentosTecnicoCampo(response.despacho.anexosVistoriador)
      this.montarDocumentosTecnicoCampo(response.despacho.anexosAdministrativo)
      const processo = await this.getProcessoById(response.despacho.idProcesso)
      this.processo = processo
      this.radios = await this.tarefa({ processo: response.despacho.idProcesso })
      if (!this.isUltimoPasso) {
        this.radios.acoes = this.radios.acoes.map(radio => {
          if (radio.valor === 'EM_ANALISE.TECNICO_DE_CAMPO.CAF') {
            radio.nome = 'Continuar análise'
          }
          return radio
        })
      }
      this.acoesRadio = this.radios.acoes
      if (this.processo) {
        this.mensagemErroPlantaMemorial = await this.getMensagemFilaPlantaEMemorial(
          this.processo.id
        )
      }

      if (processo.tipo.codigo === 'REGULARIZACAO_URBANA') {
        this.isPrimeiroPasso = false
        this.isUltimoPasso = true
        this.extensoes = ['pdf']
      }
      this.numeroProcesso = processo.numeroProcesso
      this.anexos = response.despacho.anexos
      this.dadosCadastros = response
      this.dadosCadastros.despacho.documentos = []
      this.dadosCadastros.despacho.tarefaId = this.radios.id

      this.dataDespachos = response.setores
      this.idUsuario = this.usuario.id
      this.showButtonsDecisao =
        this.usuario.perfilSelecionado.setor.codigo === 'DJ'
      this.pecasTecnicas = response.pecasTecnicas
      this.despacho = !!this.dadosCadastros?.despacho?.textoDespacho
    },
    isGeomensor () {
      return this.funcao === 'GEOMENSOR'
    },
    isFiscalizador () {
      return this.funcao === 'FISCALIZADOR'
    },
    isVistoriador () {
      return this.funcao === 'VISTORIADOR'
    },
    isAdministrativo () {
      return this.funcao === 'ADMINISTRATIVO'
    },
    setCodigoIterpa (codigo) {
      this.dadosCadastros.despacho.numeroIterpa = codigo
    },

    formataDocumento (documento) {
      return {
        id: documento.id,
        fileKey: documento.key,
        fileName: documento.nome,
        caminho: documento.caminho,
        tipoDocumento: {
          codigo: documento.tipo.codigo,
          id: documento.tipo.id,
          descricao: documento.tipo.codigo === 'RELATORIO_GERAL_VALIDACAO_GEORREFERENCIAMENTO'
            ? documento.tipo.descricao
            : documento.tipo.codigo?.replaceAll('_', ' '),
          tipo: documento.tipo.codigo
        }
      }
    },

    carregarResponsavel () {
      if (pegarResponsavel) {
        axios({
          method: 'GET',
          url: `responsavelProcesso/findByIdUsuario/${this.usuario.id}`
        }).then(response => {
          this.responsavel = response
        })
      }
    },
    async setDadosPlanilha (valor) {
      this.denominacaoImovel = valor.denominacao
      this.jsonPlanilha = valor.jsonPlanilha
      this.tipoPlanilha = valor.tipoPlanilha
      this.menssagemRetorno = valor.menssagemRetorno
      this.atualizandoJsonPlanilha = valor.subProcessoTratandoJsonUTM
      if (valor.subProcessoTratandoJsonUTM) {
        await axios({
          method: 'PUT',
          url: 'subprocesso/atualizaDadosSubProcesso',
          data: { idSubProcesso: this.idProcesso, jsonPlanilha: this.jsonPlanilha }
        })
      }
    },

    onTextChange (text) {
      this.dadosCadastros.despacho.textoDespacho = text
    },

    async getMensagemFilaPlantaEMemorial (idProcesso) {
      const resp = await axios({
        method: 'GET',
        url: `filaPlantaMemorial/verificarFilaComErro/${idProcesso}`
      })
      return resp
    },

    async atualizarDados () {
      this.dadosCadastros.despacho.denominacaoImovel = this.denominacaoImovel
      this.dadosCadastros.despacho.responsavelDto = this.responsavel
      this.dadosCadastros.despacho.loteEndereco = this.loteEndereco
      this.dadosCadastros.despacho.quadra = this.quadra
      this.dadosCadastros.despacho.rua = this.rua
      this.dadosCadastros.despacho.bairro = this.bairro
      this.dadosCadastros.despacho.complemento = this.complemento
      this.dadosCadastros.despacho.codigoImovel = this.codigoImovel
      this.dadosCadastros.despacho.codigoArtTrt = this.codigoArtTrt
      this.dadosCadastros.despacho.analiseComPlanilha = this.tipoAnalisePlanilha
      this.dadosCadastros.despacho.jsonPlanilha = this.jsonPlanilha ? this.jsonPlanilha : this.dadosCadastros.despacho.jsonPlanilha
      this.dadosCadastros.despacho.tipoPlanilha = this.tipoPlanilha
      if (this.documentoArtTrtOs?.length) {
        this.dadosCadastros.despacho.documentoArtTrtOs = this.documentoArtTrtOs[0]
      }

      if (this.isAdministrativo() && this.beneficiariosChanged) {
        await this.updateBeneficiariosByProtocolo({
          protocolo: this.processo.numeroProtocolo,
          beneficiarios: this.beneficiarios
        })
      }
    },

    updateBeneficiariosLista (beneficiarios) {
      this.beneficiariosChanged = true
      this.beneficiarios = [...beneficiarios]
    },

    voltar () {
      this.$router.push({name: 'EM_ANALISE_OS'})
    },
    async addedDoc () {
      if (this.atualizandoJsonPlanilha) {
        await this.salvar()
        this.$router.push({name: 'EM_ANALISE_OS'})
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.menssagemRetorno)
      }
    },
    setShapefile ({fileName, fileKey}) {
      this.documentosGeomensor.push({
        fileName,
        fileKey,
        tipoDocumento: {
          codigo: 'MAPAS'
        }
      })
    },
    removeShapefile () {
      this.documentosGeomensor = this.documentosGeomensor.filter(d => d.tipoDocumento.codigo !== 'MAPAS')
    },
    codigoImovelConcatedString () {
      if (this.bairro && this.quadra && this.loteEndereco && this.municipio) {
        const bairroAbreviado = this.bairro.replace('.', '').substring(0, 3)
        this.codigoImovel = `${this.municipio.codigoMunicipio}-${bairroAbreviado}-Q${this.quadra}-L${this.loteEndereco}`.toLocaleUpperCase()
      }
    },
    uploadArt (file) {
      this.documentoArtTrtOs.push({
        key: file.response,
        nome: file.name,
        tipo: {
          codigo: 'ART_TRT'
        }
      })
    },
    removeArt (documento) {
      const index = this.documentoArtTrtOs.indexOf(
        this.documentoArtTrtOs.find(m => m.key === documento.key)
      )
      this.documentoArtTrtOs.splice(index, 1)
    },
    changeRadio (value) {
      if (this.exibirTipoAnaliseGeo && this.isGeomensor() && !this.isReurb) {
        this.isUltimoPasso = value.acao === 'ARQUIVAMENTO.SISTEMA.SISTEMA.AUTOCOMPLETE'
      }
      this.dadosCadastros.despacho.acao = value.acao
      this.showRequired = value.acao !== 'ARQUIVAMENTO.SISTEMA.SISTEMA.AUTOCOMPLETE'
      if (value.usuario) {
        this.dadosCadastros.despacho.processo.usuarioEncaminhar = {
          id: value.usuario
        }
      }
    }
  }
}
</script>
<style lang="scss">
.padding {
  padding: 5px;
}

.required {
  color: firebrick;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.container-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label {
  font-weight: bold;
}

.radios-despacho-parecer {
  display: flex;
  justify-content: center;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.extra-margin-top-bottom {
  margin-top: 30px;
  margin-bottom: 30px;
}

.margin-medium-top {
  margin-top: 20px;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.error {
  border: solid 1px firebrick;
  border-radius: 5px;
}

.tipo-de-analise {
  margin-bottom: 15px;
  span {
    font-weight: bold;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/AnalisarValidarSubProcesso.vue